module.exports = __webpack_public_path__ + "img/map2.ac6171cf.png";